import md5 from 'md5';
import { defaultTo, has, isNil, path } from '../../utils/fp';
import C from './constants';

export const setFormat = (string = '') => {
  const str = `${string}`;
  const match = str.match(C.VALUE_MASK) || [];
  return str.replace(match[0], '');
};

const extractId = val => {
  const matched = (val.match(C.FACET_VALUE_MASK) || []).at(-1);
  const str = isNil(matched) ? '' : matched;
  return str.slice(1, -1);
};

export default options =>
  ({ val, count, label, order }) => ({
    id: val,
    code: extractId(val),
    label: setFormat(label),
    order: defaultTo(0, order),
    count: count === 0 ? null : count,
    isDisabled: count === 0, // should be at rendering level
    isSelected: has(md5(`${options.facetId}${val}`), defaultTo({}, options.constraints)),
    // should be at rendering level
    svgPath: path(['valueIcons', options.facetId, extractId(val)], options.config),
  });
